<nav class="navbar navbar-dark bg-transparent fixed-top navbar-expand-lg nav-main p-2" id="top">
  <div class="container">
    <a [routerLink]="['/']" class="navbar-brand text-title me-4">
      <img id="navbar-brand-logo" src="/assets/images/logo-white.png" alt="NSHM E-learning" height="50">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">

      <ul class="navbar-nav me-auto">
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/cursos']" routerLinkActive="active">Cursos</a>
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" [routerLink]="['/planos']" routerLinkActive="active">Planos</a>
        </li> -->
        <li class="nav-item">
          <a class="nav-link" *ngIf="isAuthenticated" [routerLink]="['/cursos/meus-cursos']"
            routerLinkActive="active">Meus cursos</a>
        </li>
      </ul>

      <span *ngIf="showBusca" class="p-input-icon-right me-auto input-search">
        <i class="la la-search d-block"></i>
        <input type="text" pInputText placeholder="busque por cursos...">
      </span>

      <section class="auth-section ms-auto navbar-text">
        <div *ngIf="!isAuthenticated" class="auth-controls">
          <button [routerLink]="['/autenticacao/login']" class="btn text-warning me-2 btn-sm" type="button">
            Entrar
          </button>
          <button [routerLink]="['/autenticacao/cadastro']" class="btn btn-warning me-2 btn-sm" type="button">
            Cadastre-se
          </button>
        </div>
        <span *ngIf="isAuthenticated" routerLink="/conta" class="header-user-avatar">
          <figure><img src="/assets/icons/user.svg" alt="foto de perfil"></figure>
          <strong class="px-2"> {{utilizador.nome}}</strong>
        </span>
      </section>
    </div>
  </div>
</nav>

<div class="busca-modal">
  <div class="busca-modal-container">
    <div class="container">
      <div class="custom-card">
        <h5 class="text-title">Angular & Material design</h5>
        <p class="mt-2 text-secondary">Lorem ipsum dolor sit amet consectetur adipisicing elit. In minima nam aliquam
          magnam
          dolor
          obcaecati iure nemo, ipsa ut tempora.</p>
      </div>
    </div>
  </div>
</div>